import { ToggleHoldAction } from './types';

export const toggleHoldActionCreator = (n: number): ToggleHoldAction => ({
  type: 'toggle-hold',
  payload: n,
});
